import React, { Component } from 'react';
import { Link } from 'react-router-dom';

const addresses = [
	{
		id: 146786,
		name: 'House',
		user: 172259,
		address1: '101-f',
		address2: 'vizianagaram',
		phonenumber: '7995044741',
		area: 64,
		landmark: 'skdjf',
		pincode: '534214',
		area_name: 'Madhapur',
		city: {
			id: 1,
			name: 'Chennai'
		},
		state: {
			id: 1,
			name: 'Tamil Nadu'
		},
		formatted_address: null,
		lat: null,
		lng: null,
		building: 'vizianagaram'
	},
	{
		id: 146787,
		name: 'Korukonda',
		user: 172259,
		address1: '101-f',
		address2: 'Chinna Street',
		phonenumber: '7997166294',
		area: 64,
		landmark: 'Near ramalayam',
		pincode: '535214',
		area_name: 'Madhapur',
		city: {
			id: 1,
			name: 'Chennai'
		},
		state: {
			id: 1,
			name: 'Tamil Nadu'
		},
		formatted_address: null,
		lat: null,
		lng: null,
		building: 'Chinna Street'
	},
	{
		id: 146788,
		name: 'restaurant',
		user: 172259,
		address1: 'Samba Foods',
		address2: 'takeaway',
		phonenumber: null,
		area: 66,
		landmark: null,
		pincode: '534247',
		area_name: 'Veeravasaram',
		city: {
			id: 1,
			name: 'Chennai'
		},
		state: {
			id: 1,
			name: 'Tamil Nadu'
		},
		formatted_address: null,
		lat: null,
		lng: null,
		building: null
	},
	{
		id: 146789,
		name: 'restaurant',
		user: 172259,
		address1: 'Burger N Beast',
		address2: 'takeaway',
		phonenumber: null,
		area: 76,
		landmark: null,
		pincode: '901600',
		area_name: 'Dunedin',
		city: {
			id: 8,
			name: 'Dunedin'
		},
		state: {
			id: 6,
			name: 'Dunedin'
		},
		formatted_address: null,
		lat: null,
		lng: null,
		building: null
	},
	{
		id: 146808,
		name: 'Testing',
		user: 172259,
		address1: 'asldkj',
		address2: 'asdasd',
		phonenumber: '7997166294',
		area: 74,
		landmark: 'asdasd',
		pincode: '535214',
		area_name: 'Dunedin',
		city: {
			id: 8,
			name: 'Dunedin'
		},
		state: {
			id: 6,
			name: 'Dunedin'
		},
		formatted_address: null,
		lat: null,
		lng: null,
		building: 'asdasd'
	}
];

class AddressesPage extends Component {
	constructor(props) {
		super(props);
		this.state = {
			showNewAdrs: false,
			newAddress: {
				name: '',
				phonenumber: '',
				address1: '',
				address2: '',
				landmark: '',
				pincode: ''
			},
			selectedAddrs: null
		};
	}
	componentDidMount() {
		document.getElementById('body').style.paddingTop = '0px';

		if (this.props.match && this.props.match.params && this.props.match.params.ardsId) {
			if (this.props.match.params.ardsId === 'new') this.setState({ showNewAdrs: true });
		}
		this.updateSelectAdrs();
	}
	componentDidUpdate() {
		if (this.props.addingAdrs === 'added') {
			this.props.setAddAddressLoader(false);
			this.setState({ showNewAdrs: false });
		}
	}
	updateSelectAdrs = () => {
		let selectedAdrs = localStorage.getItem('selectedAdrs');
		if (selectedAdrs) {
			selectedAdrs = JSON.parse(selectedAdrs);
			let addrsId = selectedAdrs.id;
			let ind = addresses.findIndex((adrs) => {
				return adrs.id === parseInt(addrsId);
			});
			if (ind >= 0) this.setState({ selectedAddrs: addresses[ind] });
		}
	};

	handleCancel = () => {
		this.setState({ showNewAdrs: false });
	};
	handleChange = (e) => {
		this.setState({ newAddress: { ...this.state.newAddress, [e.target.name]: e.target.value } });
	};
	canBeSubmitted = () => {
		let { name, phonenumber, address1, address2, pincode } = this.state.newAddress;
		if (name !== '' && phonenumber !== '' && address1 !== '' && address2 !== '' && pincode !== '') return true;
		return false;
	};
	saveAddress = () => {
		let address = addresses[0];
		localStorage.setItem('selectedAdrs', JSON.stringify(address));
		this.setState({ selectedAddrs: address });
		window.history.back();
	};
	handleAddrsSelect = (adrs) => {
		localStorage.setItem('selectedAdrs', JSON.stringify(adrs));
		this.setState({ selectedAddrs: adrs });
		window.history.back();
	};
	render() {
		const { addingAdrs } = this.props;
		const { showNewAdrs, newAddress, selectedAddrs } = this.state;

		return (
			<div className="addressesPage">
				<div className="plainHeader">
					<Link className="logo" to="/">
						<img src={require('assets/imgs/logo.png')} alt="" className="" />
					</Link>
				</div>
				<div className="container px-2 px-sm-3 py-3 py-sm-4 py-md-5">
					{showNewAdrs ? (
						<div className="row m-0 justify-content-center">
							<div className="col-lg-8 col-md-10 px-1 px-md-3">
								<div className="newAdrsCard">
									<div className="topSection p-4">
										<div className="mb-0">
											<h6>Add New Delivery Address</h6>
											<p className="note m-0">
												Please enter the accurate address, it will help us to serve you Better
											</p>
										</div>

										{/* <div className="form-group text-left mb-0">
											<label htmlFor="area">Area / Locality</label>
											<input type="text" className="form-control" id="area" />
										</div> */}
									</div>
									<div className="bottomSection p-4">
										<div className="form-group text-left">
											<label htmlFor="name">Name your Address</label>
											<input
												type="text"
												className="form-control"
												name="name"
												value={newAddress.name}
												onChange={this.handleChange}
											/>
										</div>
										<div className="form-group text-left">
											<label>Phone Number</label>
											<input
												type="text"
												className="form-control"
												name="phonenumber"
												value={newAddress.phonenumber}
												onChange={this.handleChange}
											/>
										</div>
										<div className="form-group text-left">
											<label>Door no / Block name</label>
											<input
												type="text"
												className="form-control"
												name="address1"
												value={newAddress.address1}
												onChange={this.handleChange}
											/>
										</div>
										<div className="form-group text-left">
											<label>Building / Apartment name</label>
											<input
												type="text"
												className="form-control"
												name="address2"
												value={newAddress.address2}
												onChange={this.handleChange}
											/>
										</div>
										<div className="form-group text-left">
											<label>Landmark</label>
											<input
												type="text"
												className="form-control"
												name="landmark"
												value={newAddress.landmark}
												onChange={this.handleChange}
											/>
										</div>
										{/* <div className="form-group text-left">
											<label>Pincode</label>
											<input
												type="text"
												className="form-control"
												name="pincode"
												value={newAddress.pincode}
												onChange={this.handleChange}
											/>
										</div> */}
										<div className="form-group text-left">
											<label>Pincode</label>
											<select
												className="form-control"
												name="pincode"
												value={newAddress.pincode}
												onChange={this.handleChange}
											>
												<option>500032 Gachibowli</option>
												<option>500084 Kondapur</option>
												<option>500032 Kondapur</option>
												<option>500032 Madhapur</option>
												<option>500032 FilmNagar</option>
											</select>
										</div>
										<button
											className="w-100 mt-2"
											disabled={!this.canBeSubmitted() || (addingAdrs && addingAdrs !== 'added')}
											onClick={this.saveAddress}
										>
											{addingAdrs && addingAdrs !== 'added' ? 'Saving...' : 'Save'}
										</button>
										<button className="w-100 mt-3 cancelBtn" onClick={this.handleCancel}>
											Cancel
										</button>
									</div>
								</div>
							</div>
						</div>
					) : (
						<div className="row m-0 justify-content-center">
							<div className="col-lg-6 px-2 px-sm-3">
								<div className="newAdrsBlock py-3 py-sm-4 px-4 px-sm-5">
									<div
										className="block text-center py-4 pointer"
										onClick={() => this.setState({ showNewAdrs: true })}
									>
										Add Delivery Address
									</div>
								</div>

								<div className="adrsList">
									{/* {loadingUserData && (
										<div className="py-3 text-center">
											<h5>Loading...</h5>
										</div>
									)} */}
									<React.Fragment>
										{addresses &&
										addresses.length > 0 && (
											<React.Fragment>
												<h6 className="pt-4 pb-1 pb-md-3">or choose a delivery address</h6>
												{addresses.map((adrs, index) => (
													<div
														className="adrsCard py-3 pointer"
														key={index}
														onClick={() => this.handleAddrsSelect(adrs)}
													>
														<div className="d-flex flex-row align-items-start">
															<div className="type">
																<i className="fa fa-home" />
															</div>
															<div className="d-flex flex-column mx-2 mx-md-3">
																<h5>{adrs.name}</h5>
																<p className="m-0">
																	{adrs.address1 && <span>{adrs.address1}, </span>}
																	{adrs.address2 && <span>{adrs.address2}, </span>}
																	{adrs.landmark && <span>{adrs.landmark}, </span>}
																	{adrs.city && <span>{adrs.city.name}, </span>}
																	{adrs.pincode && <span>{adrs.pincode} </span>}
																</p>
																{adrs.phonenumber && (
																	<p>
																		<span>{adrs.phonenumber} </span>
																	</p>
																)}
															</div>
														</div>
														<div className="checkCircle">
															{selectedAddrs &&
															selectedAddrs.id === adrs.id && (
																<i className="fa fa-check" />
															)}
														</div>
													</div>
												))}
											</React.Fragment>
										)}
									</React.Fragment>
								</div>
							</div>
						</div>
					)}
				</div>
			</div>
		);
	}
}

export default AddressesPage;
